import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SecurityUpdateWarning = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01 1v22H19V1H5.01zM17 18H7V6h10v12z"
  }));
});
SecurityUpdateWarning.displayName = 'SecurityUpdateWarning';
export var SecurityUpdateWarningDimensions = {
  height: 24,
  width: 24
};